// extracted by mini-css-extract-plugin
module.exports = {"RV-J":"EU_RV-J__3QG83"};